import script from "./AccessControlPolicyModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessControlPolicyModal.vue?vue&type=script&lang=ts&setup=true"

import "./AccessControlPolicyModal.vue?vue&type=style&index=0&id=1dfc0880&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfc0880"]])

export default __exports__